// extracted by mini-css-extract-plugin
export default {"prioriteTxt":"styles_prioriteTxt__duYHU","row":"styles_row__MkBc2","prioriteField":"styles_prioriteField__a1fxW","delayContainer":"styles_delayContainer__miCZW"};